import { useState } from "react"
import PropTypes from "prop-types"
import { validator } from "./validator"

const Row = props => {
  const { scholarship, editable, onSave, onDelete, onEdit, onCancel } = props

  const totalAmountDollars = scholarship.total_amount_cents / 100
  const totalUsedDollars =
    (scholarship.total_payments_cents - scholarship.total_refunds_cents) / 100
  const totalRemainingDollars = scholarship.total_remaining_cents / 100

  const [name, setName] = useState(scholarship.name || "")
  const [totalAmount, setTotalAmount] = useState(totalAmountDollars || 0)
  const [formValidation, setFormValidation] = useState({
    name: null,
    totalAmount: null
  })

  const validateForm = () => {
    const validation = validator({ name, totalAmount, totalUsedDollars })
    setFormValidation(validation)
    return validation
  }

  const handleDeleteClick = () => onDelete({ id: scholarship.id })

  const handleSaveClick = () => {
    const validation = validateForm()

    // Return if form is not valid
    if (validation.totalAmount || validation.name) {
      return
    }

    // If valid, call and return handleSave method
    return onSave({
      name,
      total_amount: totalAmount,
      ...(scholarship.id !== "new" && { id: scholarship.id })
    })
  }

  // Submit form if "enter" key pressed
  const handleSubmit = (e, submitCallback) => {
    if (e.key === "Enter" || e.which === 13) {
      submitCallback()
    }
  }

  const handleRowKeyPress = e => {
    if (
      e.key === "Enter" ||
      e.key === " " ||
      e.key === "Spacebar" ||
      e.which === 13 ||
      e.which === 32
    ) {
      handleRowClick()
    }
  }

  const handleRowClick = () => onEdit(scholarship.id)

  return (
    <>
      {editable.isEditing && editable.id === scholarship.id ? (
        <tr key={scholarship.id}>
          <td className="py-1" valign="top">
            <div css={{ width: 240 }}>
              <input
                autoFocus
                className={formValidation.name && "error-input"}
                type="text"
                name="name"
                placeholder="Name"
                value={name}
                onKeyPress={e => handleSubmit(e, handleSaveClick)}
                onChange={e => setName(e.target.value)}
              />
            </div>
            {formValidation.name && (
              <div className="c-error font-size-5 pt-4p">{formValidation.name}</div>
            )}
          </td>
          <td className="py-1" valign="top">
            <div css={{ width: 240 }}>
              <div className="prepended-label">
                <label className="label t-1p">$</label>
                <input
                  css={{ width: "120px !important" }}
                  className={formValidation.totalAmount && "error-input"}
                  type="number"
                  name="totalAmount"
                  placeholder="Amount"
                  value={totalAmount}
                  onKeyPress={e => handleSubmit(e, handleSaveClick)}
                  onChange={e => setTotalAmount(e.target.value)}
                />
              </div>
              {formValidation.totalAmount && (
                <div className="c-error font-size-5 pt-4p">{formValidation.totalAmount}</div>
              )}
            </div>
          </td>
          <td>${scholarship.id !== "new" && totalUsedDollars}</td>
          <td className="py-1">
            <div css={{ width: 180 }}>
              {onDelete && totalUsedDollars === 0 && (
                <button
                  className="xs-btn destroy-btn btn2"
                  onClick={handleDeleteClick}
                  onKeyPress={e => handleSubmit(e, handleDeleteClick)}
                >
                  Delete
                </button>
              )}
              <button
                className="mx-1 xs-btn quiet-btn btn2"
                onClick={() => onCancel()}
                onKeyPress={e => handleSubmit(e, onCancel)}
              >
                Cancel
              </button>
              <button
                className="xs-btn create-btn btn2"
                type="submit"
                onClick={handleSaveClick}
                onKeyPress={e => handleSubmit(e, handleSaveClick)}
              >
                Save
              </button>
            </div>
          </td>
        </tr>
      ) : (
        <tr
          id={scholarship.id}
          className="row__clickable"
          role="button"
          tabIndex="0"
          onClick={handleRowClick}
          onKeyPress={handleRowKeyPress}
        >
          <td>
            <div css={{ width: 240 }}>{scholarship.name}</div>
          </td>
          <td>
            <div css={{ width: 240 }}>${totalAmountDollars}</div>
          </td>
          <td>${totalUsedDollars}</td>
          <td>
            <div css={{ width: 180 }}>${totalRemainingDollars}</div>
          </td>
        </tr>
      )}
    </>
  )
}

Row.propTypes = {
  scholarship: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  editable: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
}

Row.defaultProps = {
  onEdit: null,
  onDelete: null
}

export default Row
